import type { SeoEntry } from '../data/seo';
import { language } from './index';

const frenchPages: Record<string, Pick<SeoEntry, 'title' | 'description'>> = {
  '/': {
    title: 'Virtuoz Solutions | Développement web et services IA',
    description: 'Virtuoz Solutions développe des applications web, des intégrations IA, des automatisations et des outils pour développeurs depuis Angers, en France.',
  },
  '/about': {
    title: 'À propos d’Enzo Chevallier | Virtuoz Solutions',
    description: 'Découvrez Enzo Chevallier, développeur et fondateur de Virtuoz Solutions, spécialisé dans le développement web, l’IA et l’automatisation.',
  },
  '/contact': {
    title: 'Contacter Virtuoz Solutions',
    description: 'Contactez Virtuoz Solutions pour vos projets de développement web, d’intégration IA, d’automatisation et de conseil informatique.',
  },
  '/portfolio': {
    title: 'Portfolio | Virtuoz Solutions',
    description: 'Une sélection d’applications web, de produits IA et de projets logiciels réalisés par Virtuoz Solutions.',
  },
  '/blog': {
    title: 'Blog Virtuoz Solutions | IA, développement web et outils de programmation',
    description: 'Des articles pratiques sur les assistants de programmation IA, le développement web, l’automatisation et les outils pour développeurs.',
  },
};

export function localizeSeo(seo: SeoEntry): SeoEntry {
  // Detail pages retain the metadata belonging to their original content.
  if (language === 'fr' && frenchPages[seo.canonicalPath]) {
    return { ...seo, ...frenchPages[seo.canonicalPath] };
  }
  if (language === 'en' && seo.canonicalPath === '/conseil-auto') {
    return {
      ...seo,
      title: 'La Bonne Voiture | Independent car advice',
      description: 'A personalized shortlist, total cost comparison and advice on how to acquire a car that suits your needs.',
    };
  }
  return seo;
}
